/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_Day_BInputs */

const en_platform_plan_day_b = /** @type {(inputs: Platform_Plan_Day_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day B`)
};

const pl_platform_plan_day_b = /** @type {(inputs: Platform_Plan_Day_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzień B`)
};

/**
* | output |
* | --- |
* | "Day B" |
*
* @param {Platform_Plan_Day_BInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_day_b = /** @type {((inputs?: Platform_Plan_Day_BInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_Day_BInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_day_b(inputs)
	return en_platform_plan_day_b(inputs)
});